module.exports = __webpack_public_path__ + "img/word.0b0d6ce0.png";